<template>
    <div class="system-management">
        <AdminPageHeader title="系统管理" subtitle="管理系统各项配置和设置" />

        <div class="management-content">
            <!-- 配置分组导航 -->
            <a-card class="config-nav-card">
                <a-menu v-model:selectedKeys="selectedConfigKeys" mode="horizontal" @click="handleConfigMenuClick">
                    <a-menu-item key="storage">
                        <CloudUploadOutlined />
                        对象存储管理
                    </a-menu-item>
                    <a-menu-item key="site">
                        <GlobalOutlined />
                        网站配置
                    </a-menu-item>
                </a-menu>
            </a-card>

            <!-- 配置内容区域 -->
            <div class="config-content">
                <!-- 对象存储管理 -->
                <ObjectStorageManagement v-if="activeConfigView === 'storage'" />

                <!-- 网站配置 -->
                <SiteConfigManagement v-else-if="activeConfigView === 'site'" />
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import { Card, Menu } from 'ant-design-vue'
import {
    CloudUploadOutlined, GlobalOutlined
} from '@ant-design/icons-vue'
import AdminPageHeader from '../../components/admin/AdminPageHeader.vue'
import ObjectStorageManagement from '../../components/admin/ObjectStorageManagement.vue'
import SiteConfigManagement from '../../components/admin/SiteConfigManagement.vue'


export default {
    name: 'SystemManagement',
    components: {
        'a-card': Card,
        'a-menu': Menu,
        'a-menu-item': Menu.Item,
        CloudUploadOutlined, GlobalOutlined,
        AdminPageHeader,
        ObjectStorageManagement,
        SiteConfigManagement
    },
    setup() {
        const activeConfigView = ref('storage')
        const selectedConfigKeys = ref(['storage'])

        // 处理配置菜单点击
        const handleConfigMenuClick = ({ key }) => {
            activeConfigView.value = key
            selectedConfigKeys.value = [key]
        }

        return {
            activeConfigView,
            selectedConfigKeys,
            handleConfigMenuClick
        }
    }
}
</script>

<style scoped>
.system-management {
    width: 100%;
    max-width: 100%;
}

.management-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.config-nav-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.config-nav-card :deep(.ant-card-body) {
    padding: 0;
}

.config-nav-card :deep(.ant-menu) {
    border-bottom: none;
}

.config-nav-card :deep(.ant-menu-item) {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px 24px;
    height: auto;
    line-height: 1.4;
}

.config-content {
    min-height: 500px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .config-nav-card :deep(.ant-menu-item) {
        padding: 12px 16px;
        font-size: 14px;
    }

    .config-nav-card :deep(.ant-menu) {
        overflow-x: auto;
        white-space: nowrap;
    }
}
</style>